import { render, staticRenderFns } from "./configOrgs.vue?vue&type=template&id=882d5612&scoped=true&"
import script from "./configOrgs.vue?vue&type=script&lang=js&"
export * from "./configOrgs.vue?vue&type=script&lang=js&"
import style0 from "./configOrgs.vue?vue&type=style&index=0&id=882d5612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d5612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('882d5612')) {
      api.createRecord('882d5612', component.options)
    } else {
      api.reload('882d5612', component.options)
    }
    module.hot.accept("./configOrgs.vue?vue&type=template&id=882d5612&scoped=true&", function () {
      api.rerender('882d5612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_reward_configuration/form/components/configOrgs.vue"
export default component.exports